if (window.location.host === 'qa.pinesol.com') {
  window.Userback = window.Userback || {};
  Userback.access_token = '30556|60470|dGHmxDMmE6LfBnNZcETT7bt1B';
  (function (d) {
    var s = d.createElement('script');
    s.async = true;
    s.src = 'https://static.userback.io/widget/v1.js';
    (d.head || d.body).appendChild(s);
  })(document);
}
